import React from 'react';
import { useConfig } from '../../../Config/useConfig';
import { useHardwareInfo } from '../../../DeviceData/useHardwareInfo';
import { useUserAppConfig } from '../../../DeviceData/useUserAppConfig';
import { AdminServiceMenu } from '../../../ServiceMenuScreen/AdminServiceMenu';
import { UserServiceMenu } from '../../../ServiceMenuScreen/UserServiceMenu';
import { TextPage } from '../../../TextPage/TextPage';
import { useMenuApi } from '../../../MenuContainer/useMenuApi';
export function Hw4Page() {
  var config = useConfig();
  var userAppConfig = useUserAppConfig();
  var hardwareInfo = useHardwareInfo();
  var menuApi = useMenuApi();
  var backTo = config.backLocation || undefined;
  var hw4Config = userAppConfig && userAppConfig.hw4;
  var userMode = hw4Config && hw4Config.userMode;
  var title = hardwareInfo && hardwareInfo.modelName;

  if (!hw4Config || !hardwareInfo) {
    return /*#__PURE__*/React.createElement(TextPage, {
      backTo: backTo
    }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
  }

  return userMode ? /*#__PURE__*/React.createElement(UserServiceMenu, {
    backTo: backTo,
    title: title,
    menuApi: menuApi
  }) : /*#__PURE__*/React.createElement(AdminServiceMenu, {
    backTo: backTo,
    title: title,
    menuApi: menuApi
  });
}